module.exports = __webpack_public_path__ + "0e90d512e1ccf0a774972980c2e590c8.svg";